import { render } from "./eq-modal.vue?vue&type=template&id=09dc3da8"
import script from "./eq-modal.vue?vue&type=script&lang=js"
export * from "./eq-modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/vc4a/vc4a/wp-content/themes/vc4africa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__